/**
 * Générateur — Automatisme : multiplication de puissances de même exposant
 * positif de deux nombres (2³ × 5³ = 10³).
 * Attendu ID : 1219 | Niveau : 3ème | Domaine : Puissances
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 11, ligne 745).
 *
 * ── Les clés meme_exposant_* de gen_1218 (modèle 1101/1105) ──────────────
 * Un fichier, deux jeux de clés : gen_1218 porte aⁿ × aᵐ (même base) ET
 * aⁿ × bⁿ (même exposant, clés meme_exposant_*), parce que les deux
 * automatismes partagent le domaine, les écritures, les familles d'erreurs
 * croisées (la règle de l'un appliquée à l'autre) et la fiche. Ici seules
 * les clés meme_exposant_* sont servies, payload re-badgé (attendu 1219) ;
 * les solveurs sont ceux de 1218.
 */
import { generate as genererPuissances, CATEGORIES_MEME_EXPOSANT } from './gen_1218';
import { randomChoice } from '../../../utils';

const ATTENDU_ID = 1219;

export const CATEGORIES = CATEGORIES_MEME_EXPOSANT;

const CLES = CATEGORIES_MEME_EXPOSANT.flatMap((c) => c.formatsList.map(({ key }) => key));

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && CLES.includes(typeExercice)) key = typeExercice;
    else if (typeExercice) {
        const matching = CLES.filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(CLES);
    } else key = randomChoice(CLES);
    const payload = genererPuissances(key);
    payload.attendu = ATTENDU_ID;
    return payload;
};
